import Button from 'components/Button'
import TextBody from 'components/TextBody'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'

/**
 * @param onClick
 * @param children
 * @param textStyle
 * @param rest
 * @param Component
 * @returns {JSX.Element}
 * @constructor
 */
export default function TextButton ({
  onClick,
  children,
  textStyle,
  Component = TextBody,
  ...rest
}) {
  const style = (
    getStyleComponentUtil(
      {
        color: STYLES_COLOR.BLUE
      },
      textStyle
    )
  )

  return (
    <Button
      {...rest}
      onClick={onClick}
    >
      <Component
        {...rest}
        fw={500}
        style={style}
      >
        {children}
      </Component>
    </Button>
  )
}
